const hashCode = function(str) { // java String#hashCode
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
};

const intToRGB = function(i) {
    var c = (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return '00000'.substring(0, 6 - c.length) + c;
};

const invertColor = function(hex, bw) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
            ? '#000000'
            : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return '#' + r.padStart(2, '0') + g.padStart(2, '0') + b.padStart(2, '0');
};

const maxLength = function(array) {
    return array.sort(function(a, b) { return b.length - a.length; })[0].length;
};

const eventContexts = {
    'container': [
        'onSetupComplete',
        'onMouseWheel',
        'onScroll',
        'onResize',
        'onResizing',
        'onEnterFullScreen',
        'onExitFullScreen',
        'onCourseDataCreated',
        'onLoadComplete',
    ],
    'container.loader': [
        'onAllDone',
    ],
    'container.courseData': [
        'onCourseStatusUpdated',
    ],
    'container.audioManager': [
        'onAudioToggle',
        'onAudioPlay',
        'onAudioLoad',
        'onAudioFinish',
        'onAudioPlaying',
        'onAudioToggle',
        'onUpdate',
    ],
    'container.screenManager': [
        'onPageSuspended',
        'onPageRestored',
        'onPageAdded',
        'onPageRemoved',
        'onBlockInitialized',
        'onBlockRendered',
    ],
    'container.router.pages': [
        'onLoadComplete',
    ],
    'container.lmsProperties': [
        'onSetSuspendData',
        'onSetCmiData',
    ],
    'container.componentList.CardDeck': [
        'onFlipCardsComplete',
    ],
    'container.componentList.HelpPopup': [
        'onContentMatched',
        'onNoContentMatched',
        'onHide',
    ],
    'container.componentList.FirebaseStorage': [
        'userSignOut',
        'afterUserSignOut',
        'userDataLoad',
        'afterUserDataLoad',
    ],


    /* Doesn't work */
    // 'Block': [
    //     'onDataCreated',
    //     'onRendered',
    //     'onDestroy',
    // ]
};

const STATE = {
    enabled: true,
};

window.EventLogger = Component.extend({
    name: 'EventLogger',

    initialize(config = {}) {
        STATE.enabled = config.enabled !== undefined ? config.enabled : true;
    },

    setup(container) {
        // console.log('ALL BLOCKS', container.courseData.pages.models);

        const longestPath = maxLength(Object.keys(eventContexts));
        const longestEventName = maxLength(Object.values(eventContexts).flat());

        const options = {
            pathLength: longestPath,
            eventLength: longestEventName
        };

        Object.entries(eventContexts).forEach(([path, eventArray]) => {
            const object = eval(path);
            options.pathBackground = intToRGB(hashCode(path));
            options.pathColor = invertColor(options.pathBackground);
            eventArray.forEach(eventName => {
                options.eventBackground = intToRGB(hashCode(eventName));
                options.eventColor = invertColor(options.eventBackground);
                this.logEvent(
                    object,
                    path,
                    eventName,
                    options
                );
            });
        });
    },

    logEvent(object, path, eventName, options) {
        const generic = 'font-weight: 900; padding: 0 0 0 5px; border-radius: 4px; margin-right: 0.5em;';
        const css = 'background: white; color: black;';
        const pathCss = `border-left: 10px solid #${options.pathBackground}; background: rgba(0,0,0,0.3); color: white;`;
        const eventCss = `border-left: 10px solid #${options.eventBackground}; background: rgba(0,0,0,0.3); color: white;`;
        path = path.padEnd(options.pathLength, ' ');
        eventName = eventName.padEnd(options.eventLength, ' ');

        if (STATE.enabled) {
            console.log(
                `%cLISTENING TO %c${path} %c${eventName}`,
                css + generic,
                pathCss + generic,
                eventCss + generic,
            );
        }

        this.listenTo(object, eventName, event => {
            if (!STATE.enabled) {
                return;
            }

            const date = new Date();
            const formatted = new Intl.DateTimeFormat(
                'en',
                {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                }
            ).format(date);
            const ms = date.getMilliseconds().toString().padStart(3, ' ');

            console.groupCollapsed(
                `%cEVENT FIRED @ ${formatted} ${ms}ms %c${path} %c${eventName}`,
                css + generic,
                pathCss + generic,
                eventCss + generic,
            );
            console.log(event);
            console.groupEnd();
        });
    },

    on() {
        STATE.enabled = true;
    },

    off() {
        STATE.enabled = false;
    }
});